(function(){
  var i = 0,
      a = 0,
      divsInUl = false,
      currentElement = null,
      tabParent = document.getElementById("js-tabAccordion"),
      tabLinks = tabParent.getElementsByTagName('li'),
      tabContentContainer = document.getElementById('tabContainer'),
      tabContent = tabContentContainer.getElementsByTagName('div');



  function switchTab(event){

    for(i = 0; i < tabContent.length; i = i + 1){
      $(tabParent).find('div').removeClass('active');
      $(tabParent).find('li').removeClass('active');
      $(tabContent[i]).removeClass('active');
    }

    if(event.target){
      $(document.getElementById(event.currentTarget.getAttribute('data-content-id'))).addClass('active');
      $(event.currentTarget).addClass('active');
    }else{
      $(document.getElementById(event.srcElement.getAttribute('data-content-id'))).addClass('active');
      $(event.srcElement).addClass('active');
    }
  }

  for (var i = 0; i < tabLinks.length; i = i + 1){
    if (tabLinks[i].addEventListener) {
      tabLinks[i].addEventListener("click", switchTab, false);
    }
    else {
      tabLinks[i].attachEvent("onclick", switchTab);
    }
  }

  function addDivsInUl(){
    for(i = 0; i < tabLinks.length; i = i + 1){
      currentElement = tabContent[i].cloneNode(true);
      tabLinks[i].appendChild(currentElement);
    }
    $(tabContentContainer).addClass('disable');
    divsInUl = true;
  }

  function removeDivsInUl(){
    for(i = 0; i < tabLinks.length; i = i + 1){
      $(tabLinks[i]).find('div').remove();
    }
    $(tabContentContainer).removeClass('disable');
    divsInUl = false;
  }

  function onScreenResize(){
    if(window.innerWidth < 768){
      if(!divsInUl){
        addDivsInUl();
      }
    } else {
      if(divsInUl){
        removeDivsInUl();
      }
    }
  }

  if(window.innerWidth < 768){
    if(!divsInUl){
      addDivsInUl();
    }
  };

  window.addEventListener('resize', onScreenResize);
})();
